<template>
    <vx-card v-if="loading">
        <h3>Loading.. Please wait..</h3>
    </vx-card>
    <div v-else>
        <h3 class="mt-2 mb-3">Safety Program Approve</h3>
        <template v-if="showReview">
            <vx-card noShadow noRound>
    
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
                        <vs-row>
                            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                                <vs-input
                                    :value="data.id ? `#${data.id}` : 'Auto Generated'"
                                    label="ID"
                                    readonly
                                    class="w-full"
                                />
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                                <label class="vs-input--label block">Resource Allocation</label>
                                <div class="flex mt-3 align-center">
                                    <vs-radio v-model="data.resource_allocation" vs-name="resource_allocation" vs-value="i">Internal</vs-radio>
                                    <vs-radio v-model="data.resource_allocation" vs-name="resource_allocation" vs-value="e" class="mx-3">External</vs-radio>
                                </div>
                                <small class="block text-danger mt-1" v-if="api_errors.resource_allocation">
                                    {{ api_errors.resource_allocation.join(', ') }}
                                </small>
                            </vs-col>
                        </vs-row>
                        <vs-row  v-if="data.resource_allocation == 'e'">
                            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                                <SelectForeign
                                    :model.sync="data.allocated_resource"
                                    label="Select Vendor"
                                    placeholder="Type to Search..."
                                    :multiple="false"
                                    :load_initial="true"
                                    :label_keys="['first_name', 'last_name']"
                                    :show_id_in_label="false"
                                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${allocated_resource_dropdown()}&is_active=true`"
                                    container_class="w-full"
                                    input_class=""
                                    :use_id_as_value="false"
                                    :close_on_select="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.allocated_resource">
                                    {{ api_errors.allocated_resource.join(', ') }}
                                </small>
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                                <SelectForeign
                                    :model.sync="data.allocated_engineer"
                                    label="Select Employee"
                                    placeholder="Type to Search..."
                                    :multiple="false"
                                    :load_initial="true"
                                    :label_keys="['first_name', 'last_name']"
                                    :show_id_in_label="false"
                                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${allocated_engineer_external_dropdown()}&is_active=true`"
                                    container_class="w-full"
                                    input_class=""
                                    :use_id_as_value="false"
                                    :close_on_select="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.allocated_engineer">
                                    {{ api_errors.allocated_engineer.join(', ') }}
                                </small>
                            </vs-col>
                        </vs-row>
                        <vs-row v-else>
                            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                                <SelectForeign
                                    :model.sync="data.allocated_engineer"
                                    label="Select Employee"
                                    placeholder="Type to Search..."
                                    :multiple="false"
                                    :load_initial="true"
                                    :label_keys="['first_name', 'last_name']"
                                    :show_id_in_label="false"
                                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${allocated_engineer_dropdown()}&is_active=true`"
                                    container_class="w-full"
                                    input_class=""
                                    :use_id_as_value="false"
                                    :close_on_select="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.allocated_engineer">
                                    {{ api_errors.allocated_engineer.join(', ') }}
                                </small>
                            </vs-col>
                        </vs-row>
                        <vs-row>
                            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                                <SelectDate
                                    :selectedDate.sync="data.resolution_started_on"
                                    label="Start"
                                    class="w-full"
                                    :allow_all_dates="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.resolution_started_on">
                                    {{ api_errors.resolution_started_on.join(', ') }}
                                </small>
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                                <SelectDate
                                    :selectedDate.sync="data.resolution_ended_on"
                                    label="End"
                                    class="w-full"
                                    :allow_all_dates="true"
                                />
                                <small class="block text-danger mt-1" v-if="api_errors.resolution_ended_on">
                                    {{ api_errors.resolution_ended_on.join(', ') }}
                                </small>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                        <h3 class="text-primary">Summary</h3>
                        <vs-divider />
                        <vs-row>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                                <strong>Date Created: </strong> <FormatText :text="data.created_on" format="datetime" />
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                <strong>Reported Name: </strong> {{ data.reported_by.first_name }} {{ data.reported_by.last_name }}
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                <strong>Type of Program: </strong> {{ data.program_type ? data.program_type.name : '' }}
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                <strong>Time of Activity(HH:MM): </strong> {{ data.time_of_activity }}
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                                <strong>Event Description: </strong> {{ data.event_description }}
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
    
                <vs-row class="mt-base">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";
import moment from "moment";

export default {
    data() {
        return {

            loading: true,

            data: null,

            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        showReview() { 
            return this.hasAccess('review', `safety_program`, ['all', 'assigned'], this.data.assigned_reviewers.map(v=>v.id)) 
        },
    },
    methods: {
        init() {
            this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.safety_program + this.$route.params.safety_program_id + '/'

            this.$vs.loading()
            this.loading = true

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.loading = false
                    if (res.status != 'p') {
                        return this.$router.push({name: 'safety-program-list'})
                    }
                    this.data = res
                    if (!this.data.resolution_started_on)
                        this.data.resolution_started_on = moment().format('YYYY-MM-DD')
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let payload = {
                action: 'approve',
                allocated_resource: this.data.allocated_resource,
                allocated_engineer: this.data.allocated_engineer,
                resource_allocation: this.data.resource_allocation,
                resolution_started_on: this.data.resolution_started_on,
                resolution_ended_on: this.data.resolution_ended_on,
            }

            this.submit_disabled = true
            this.$vs.loading()
            this.api_errors = {}

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_action, this.data.id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    this.$router.push({name: 'safety-program-list'})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        allocated_resource_dropdown() {
            let permission = []
            permission.push(`edit_external_resolution__all__safety_program`)
            permission.push(`edit_external_resolution__assigned__safety_program`)

            return permission.toString()
        },
        allocated_engineer_external_dropdown() {
            let permission = []
            permission.push(`review_external_resolution__all__safety_program`)
            permission.push(`review_external_resolution__assigned__safety_program`)

            return permission.toString()
        },
        allocated_engineer_dropdown() {
            let permission = []
            permission.push(`edit_resolution__all__safety_program`)
            permission.push(`edit_resolution__assigned__safety_program`)

            return permission.toString()
        }
    },
}
</script>
